import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "id", -1)
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "fw-semibold"
}
const _hoisted_19 = {
  key: 0,
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#4ed06e"}
}
const _hoisted_20 = {
  key: 1,
  class: "fa-solid fa-xmark fa-xl",
  style: {"color":"#d92626"}
}
const _hoisted_21 = {
  key: 0,
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#4ed06e"}
}
const _hoisted_22 = {
  key: 1,
  class: "fa-solid fa-xmark fa-xl",
  style: {"color":"#d92626"}
}
const _hoisted_23 = { style: {"color":"rgb(124, 143, 162)"} }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-download fa-xl",
  style: {"color":"#5b6b86"}
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]

import { onMounted, ref } from "vue";
import ReportService from "@/projects/tenant/modules/report/services/ReportService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import TimeShow from "@/components/TimeShow.vue";
import { getImageUrl } from "@/core/plugins/ProcessImageLink";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportRecord',
  setup(__props) {

const reports = ref<Array<any>>([]);
const isLoading = ref(false);
const criteria = ref({
  page: 1,
  size: 10,
});

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  isLoading.value = true;
  try {
    const res = await ReportService.queryRequests(criteria.value);
    reports.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const downloadReportFile = async (_item) => {
  const downloadUrl = getImageUrl(_item.fileName);
  try {
    await TenantGlobalService.downloadFileByLink(downloadUrl, _item.fileName);
  } catch (error) {
    MsgPrompt.error(error);
  }
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.ibRebateReport")), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.hasData")), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.valid")), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && reports.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.reportRequest.${item.type}`)), 1),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        (!item.isEmpty)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                          : (_openBlock(), _createElementBlock("i", _hoisted_20))
                      ]),
                      _createElementVNode("td", null, [
                        (!item.isExpired)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                          : (_openBlock(), _createElementBlock("i", _hoisted_22))
                      ]),
                      _createElementVNode("td", _hoisted_23, [
                        (item.isGenerated)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t("status.readyForDownload")), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t("status.processing")) + " ... ", 1)
                            ], 64))
                      ]),
                      _createElementVNode("td", null, [
                        (item.isGenerated)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "#",
                              onClick: ($event: any) => (downloadReportFile(item))
                            }, _hoisted_26, 8, _hoisted_24))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ])
  ]))
}
}

})